'use client';

import { useQueries } from '@tanstack/react-query';

import { useAuth } from '@sola/auth-sdk/store.js';

import { MOCK_SUPPORTER_MIXED_COMMITMENTS } from './mocks/supporters';
import { SupporterQuery } from './queries';

const useReadyForQueries = () => {
  const { authUser } = useAuth('authUser');
  return {
    isReady:
      process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER || authUser?.authUserGlobalId,
    globalId: authUser?.authUserGlobalId,
  };
};

/**
 * Gets supporters main payment methods information.
 */
// export const useSupporterPaymentMethods = () => {
//   const { isReady, globalId } = useReadyForQueries();
//   return useQuery({
//     queryKey: ['supporterPaymentMethods'],
//     // If this is running, we have a global id.
//     queryFn: () => getPaymentMethods(globalId as string),
//     enabled: !!isReady,
//   });
// };
export const useSupporterQuery = (
  supporterQueries: SupporterQuery | SupporterQuery[],
) => {
  const { isReady, globalId } = useReadyForQueries();
  const queries = Array.isArray(supporterQueries)
    ? supporterQueries
    : [supporterQueries];

  const queryResults = useQueries({
    queries: queries.map((supporterQuery) => {
      return {
        queryKey: supporterQuery.queryKey,
        // We should always have a globalId if this runs bc of isReady logic.
        queryFn: () =>
          process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER
            ? MOCK_SUPPORTER_MIXED_COMMITMENTS
            : supporterQuery.queryFn(globalId as string),
        enabled: !!isReady,
        refetchOnWindowFocus: false,
      };
    }),
  });

  return {
    ...(queries.length === 1
      ? queryResults[0]
      : {
          data: queryResults.map((result) => result.data),
          isFetched: queryResults.every((result) => result.isFetched),
          isFetching: queryResults.some((result) => result.isFetching),
          isLoading: queryResults.some((result) => result.isLoading),
          isPending: queryResults.some((result) => result.isPending),
          isPaused: queryResults.some((result) => result.isPaused),
          isError: queryResults.some((result) => result.isError),
          isSuccess: queryResults.every((result) => result.isSuccess),
          queries: queryResults,
        }),
  };
};
